import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import UserActions from "../../store/actions/UserActions";
import { useTranslation } from "react-i18next";

const UserNavigation = () => {
  const { isLoggedin, user } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  if (!isLoggedin) {
    return null;
  }

  const logoutHandler = () => {
    dispatch(UserActions.logout());
    navigate("/");
  };

  return (
    <div className="dropdown current-user">
      <button
        className="navmenu-toggler dropdown-toggle hide-toggle-icon"
        type="button"
        id="navbarToggleUserMenu"
        data-bs-toggle="dropdown"
        data-bs-target="#navbarToggleUserMenu"
        aria-controls="navbarToggleUserMenu"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <img src={user.imageURL} />
      </button>
      <ul
        className="dropdown-menu dropdown-menu-end user-menu"
        aria-labelledby="navbarToggleUserMenu9"
      >
        <li>
          <div class="user-name-tier">
            {user.firstname} {user.lastname} <span class="tier">Free</span>
          </div>
        </li>
        <li>
          <Link className="dropdown-item" to="/profile">
            <i className="bi bi-gear" /> {t("navbar.settingsLink")}
          </Link>
        </li>
        <li>
          <button className="dropdown-item" onClick={logoutHandler}>
            <i className="bi bi-door-closed" /> {t("navbar.logoutLink")}
          </button>
        </li>
      </ul>
    </div>
  );
};

export default UserNavigation;
